/**
 *
 * EmailTypeFilter
 *
 */
import * as React from 'react';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { IFilterComponentProps } from '../IFilterComponentProps';
import { EmailTypePicker } from 'app/components/pickers/StaticOptionsPickers/EmailTypePicker';
import { EmailTypeUnion } from 'api/odata/generated/enums/EmailType';

export const EmailTypeFilter = (props: IFilterComponentProps) => {
  const handleOnChange = (value: EmailTypeUnion | null) => {
    props.onChange(value);
  };
  const { t } = useTranslation();
  return (
    <EmailTypePicker
      value={props.value}
      onChange={handleOnChange}
      isOpen={props.open}
      placeholder={t(translations.AllValues)}
      ariaLabel={props.label}
      size="small"
      id={props.id}
    />
  );
};
export default EmailTypeFilter;
